<template>
  <div>
    <app-board :header="false" class="p-3 mb-3">
      <div class="row border-bottom pb-4">
        <div class="col-12 col-md-3 text-secondary text-uppercase">
          Profile Type
        </div>
        <div class="col-12 col-md-9">
          {{ getSessionData('profile_caption') }}
        </div>
      </div>

      <div class="row border-bottom pb-4 pt-2">
        <div class="col-12 col-md-3 text-secondary text-uppercase">
          Subscription Plan
        </div>
        <div class="col-12 col-md-9">
          {{ getSessionData('subscription_title') }}
        </div>
      </div>


      <div class="row border-bottom pb-4 pt-2">
        <div class="col-12 col-md-3 text-secondary text-uppercase">
          Started at
        </div>
        <div class="col-12 col-md-9">
          {{ getSessionData('subscription_started_from') }}
        </div>
      </div>


      <div class="row border-bottom pb-4 pt-2">
        <div class="col-12 col-md-3 text-secondary text-uppercase">
          Valid Until
        </div>
        <div class="col-12 col-md-9">
          {{ getSessionData('subscription_valid_until') }}
        </div>
      </div>

      <div class="row border-bottom pb-4 pt-2">
        <div class="col-12 col-md-3 text-secondary text-uppercase">
          Status
        </div>
        <div class="col-12 col-md-9">
          {{ getSessionData('subscription_status') }}
        </div>
      </div>

      <!--<div class="row border-bottom pb-4 pt-2">
        <div class="col-12 col-md-3 text-secondary text-uppercase">
          Expires In
        </div>
        <div class="col-12 col-md-9">
          30 days
        </div>
      </div>-->
    </app-board>

    <app-board :header="false" class="p-3 mb-3">
      <el-row>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
          <dg-select-field
              :field_span="19"
              :label_span="24"
              :options="subscribePlansList"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="planUpdated"
              field_mark="required"
              label="Renewal Package"
              name="renewal_package"
              rules=""></dg-select-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
          <div class="float-right mt-4">
            <dg-button v-if="this.amtPayment" :click="renewSubscription" :loading="requestOn" :translate="false" :type="actionButtonType"
                       fieldSize="normal" icon="el-icon-refresh-right" text="Renew"></dg-button>
          </div>
        </el-col>
      </el-row>
      <el-row class="mt-0">
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
          <span class="error-field-validate-message" v-if="requestErrorMessage">{{ requestErrorMessage }}</span>
        </el-col>
      </el-row>

      <subscriptionForm :amt="amtPayment" :customData="customData" :packageName="packageName"
                        v-if="registrationCompleted"></subscriptionForm>
    </app-board>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import moduleForm from '@/modules-config/mixins/moduleForm.js';
import {getLS} from "devegram-javascript-util";

export default {
  mixins: [moduleForm],
  components: {
    subscriptionForm: () => import('@/app/portals/cpanel/paypal-subscription-forms/SubscriptionForm'),
  },
  beforeMount() {
    this.getUserSubscriptionPlansNoTrialList().then(r => {
      this.subscribePlansList = r
    })
  },
  methods: {
    getSessionData(key) {
      return getLS('user')[key]
    },
    renewSubscription() {
      if (this.amtPayment && this.packageName ) {
        let prepareRenewalApiData = {
          data: {
            subscription_plan_id: this.selectedPlanId
          }
        }
        this.prepareRenewalSubscription(prepareRenewalApiData).then(r => {
          this.customData = r
          this.registrationCompleted = true
        })
      }
    },
    planUpdated(inputField) {
      let value = inputField.field.field_value
      this.selectedPlanId = value
      this.getSubscriptionPlanInfo(value).then( r => {
        this.planDetails = r
        this.amtPayment = r.rate
        this.packageName = r.title
      })
    },
    ...mapActions('user-api', {
      getUserSubscriptionPlansNoTrialList: 'getUserSubscriptionPlansNoTrialList',
      getSubscriptionPlanInfo: 'getSubscriptionPlanInfo',
      prepareRenewalSubscription: 'prepareRenewalSubscription'
    }),
  },
  data() {
    return {
      selectedPlanId: false,
      registrationCompleted: false,
      requestErrorMessage: false,
      editMode: true,
      planDetails: false,
      amtPayment: false,
      packageName: false,
      customData: '',
      validData: true,
      requestOn: false,
      subscribePlansList: [],
      subscription_plan: null,
      entityDataToBind: $store.state['user-state'].profile
    }
  }

}
</script>
